import { AlertTriangle } from "lucide-react";

/**
 * DOOSP / IMCAC Global Legal Disclaimer.
 *
 * Displayed on:
 *   - Home "Our mission" section (banner)
 *   - Global footer (footer variant)
 *   - /verify, /register, Dashboard, Result pages (banner)
 *
 * Two visual variants: `banner` (inline warning-style, prominent) and
 * `footer` (compact, muted, for site-wide footers).
 */
export function LegalDisclaimer({ variant = "banner", className = "" }) {
  return (
    <BodyRenderer variant={variant} className={className} />
  );
}

function BodyRenderer({ variant, className }) {
  const paragraph = (
    <>
      <strong>DOOSP</strong> is a specialty division of <strong>IMCAC</strong> providing
      occupational safety training, competency assessment, and professional certification. IMCAC
      is an <strong>independent competency assessment and certification body</strong>. IMCAC does{" "}
      <strong>not</strong> provide academic programs or medical licenses. IMCAC certifications are
      awarded based on <strong>competency-based assessments</strong> and do <strong>not</strong>{" "}
      constitute a license to practice, nor do they replace{" "}
      <strong>professional registration requirements imposed by national regulatory authorities</strong>.
      IMCAC is a <strong>registered Non-Profit Organisation under Section 8 of the Companies
      Act, India</strong>.
    </>
  );

  if (variant === "footer") {
    return (
      <div
        className={`text-[11px] leading-relaxed text-zinc-400 max-w-4xl mx-auto ${className}`}
        data-testid="legal-disclaimer-footer"
      >
        <div className="font-semibold text-zinc-300 uppercase tracking-widest text-[10px] mb-2">
          Legal disclaimer
        </div>
        <p>{paragraph}</p>
      </div>
    );
  }

  return (
    <aside
      className={`border-l-4 border-amber-500 bg-amber-50 text-amber-950 px-5 py-4 rounded-r-md ${className}`}
      role="note"
      aria-label="IMCAC legal disclaimer"
      data-testid="legal-disclaimer-banner"
    >
      <div className="flex items-start gap-3">
        <AlertTriangle className="h-5 w-5 text-amber-600 flex-shrink-0 mt-0.5" strokeWidth={2} />
        <div className="text-sm leading-relaxed">
          <div className="font-bold uppercase tracking-widest text-[11px] text-amber-900 mb-1.5">
            Legal disclaimer
          </div>
          <p>{paragraph}</p>
        </div>
      </div>
    </aside>
  );
}

export default LegalDisclaimer;
